<template>
  <PageMain class="app-container trace-page">
    <div class=" mt-20 bg-w pl-80 pr-80 pb-100">
      <div class="fs-24 fs-b f-c-b  pt-40 pb-40 t-center">查询快递</div>
      <div class=" flex a-center mb-20 ">
        <span class="fs-24 fs-b f-c-b1">快递单号：</span>
        <a-auto-complete v-model="number" option-label-prop="title" placeholder="请输入运单号" class="flex1 ml-10 mr-10" @select="select" @search="handleSearch">
          <template slot="dataSource">
            <a-select-option v-for="i in shipperList" :key="i.shipperCode" :value="JSON.stringify(i)" :title="i.number">
              {{ i.title }}
            </a-select-option>
          </template>
          <a-input>
            <a-button
              ref="btn"
              slot="suffix"
              style="margin-right: -12px"
              class="search-btn"
              type="primary"
            >
              快速查件
            </a-button>
          </a-input>
        </a-auto-complete>
        <!--  -->
        <!-- <a-button type="primary" @click="search">
          快速查件
        </a-button> -->
      </div>
      <div v-if="list&&list.length>0" class="bg-grey pt-40 pb-40 pl-108  pr-108">
        <div v-for="(i,index) in list" :key="index" class="trace-item ">
          <div class="flex a-center " :class="index===0?'f-c-blue':''">
            <div class="w-128">{{ i.acceptTime }}</div>
            <div class="ml-14 mr-10 fs-24 "><a-icon :type="index===0?'check-circle':'up-circle'" /></div>
            <div class="word-b flex1">{{ i.acceptStation }}</div>
          </div>
          <div v-if="index<list.length-1" class="h-line" />
        </div>
      </div>
      <div v-else class="bg-grey pt-40 pb-40 pl-108  pr-108">
        <div class="bg-grey "><div class="ant-empty ant-empty-normal"><div class=" t-center"><img class="w-120" src="@/assets/trace/empty@2x.png" alt=""></div><p class="ant-empty-description">暂无数据</p></div></div>
      </div>
    </div>
  </PageMain>
</template>
<script>

export default {
  name: 'Trace',
  data() {
    return {
      number: '',
      shipperList: [

      ],
      list: []
    }
  },
  watch: {
    shipperList(n) {

    }
  },

  async mounted() {
    if (this.$route.query.code) {
      this.number = this.$route.query.code
      await this.handleSearch(this.number)
      this.$refs.btn.$el.click()
    }
  },
  methods: {
    async search(val) {
      if (this.shipperList.length > 0) {
        this.select(JSON.stringify(this.shipperList[0]))
      }
    },
    async select(val) {
      const v = JSON.parse(val)
      const res = await this.$http(this.$api.logisticsQueryRoute, {
        'waybillCode': v.number,
        'shipperCode': v.shipperCode
      })
      this.list = res && res.traces && res.traces.reverse()
    },
    async handleSearch(code) {
      if (!code) {
        return
      }
      try {
        const res = await this.$http(this.$api.logisticsRecognizeLogisticsNumber, {
          'waybillCode': code
        })
        this.shipperList = res.map((el) => {
          return { ...el, title: el.shipperName + ' ' + code, number: code }
        })
      } catch (error) {
        this.shipperList = []
      }
    },
    async getList() {
      if (!this.number) {
        this.$message.warning('请输入运单号')
        return
      }

      const res = await this.$http(this.$api.logisticsQueryRoute, {
        'waybillCode': this.number
      })
      this.list = res
    }
  }
}
</script>

<style lang="scss" >
.trace-page {
  .bg-grey{
    background: rgba(245, 247, 250, 1);
  }
  .trace-item{

  }
  .word-b{
    word-break: break-all;
  }
  .h-line{
    margin-left: 154px;
    margin-top: 2px;
    margin-bottom: 2px;
    width: 1px;
    height: 32px;
    background: rgba(0, 0, 0, 0.15);
  }
  .bg-blue1{
    background: rgba(240, 245, 255, 1);
  }
  .text-icon-s{
    width: 20px;
    height: 20px;
    background: #000;
    color: #fff;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    line-height: 20px;
  }
  .text-icon-r{
    width: 20px;
    height: 20px;
    background: rgba(24, 144, 255, 1);
    color: #fff;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    line-height: 20px;
  }
}
</style>
